import { create } from 'zustand'
import type { User } from '@/types'

// Allowed users during private beta
const ALLOWED_EMAILS = [
  'mr.brecht@gmail.com',
  'michael.ithome@gmail.com',
]

interface AuthState {
  isAuthenticated: boolean
  isAllowed: boolean
  isLoading: boolean
  user: User | null
  error: string | null
}

interface AuthActions {
  setUser: (user: User | null) => void
  setLoading: (isLoading: boolean) => void
  setError: (error: string | null) => void
  logout: () => void
}

type AuthStore = AuthState & AuthActions

const checkIsAllowed = (email: string | undefined): boolean => {
  if (!email) return false
  return ALLOWED_EMAILS.includes(email.toLowerCase())
}

export const useAuthStore = create<AuthStore>((set) => ({
  // Initial state
  isAuthenticated: false,
  isAllowed: false,
  isLoading: true,
  user: null,
  error: null,

  // Actions
  setUser: (user) =>
    set({
      user,
      isAuthenticated: user !== null,
      isAllowed: checkIsAllowed(user?.email),
      isLoading: false,
      error: null,
    }),

  setLoading: (isLoading) => set({ isLoading }),

  setError: (error) =>
    set({
      error,
      isLoading: false,
    }),

  logout: () =>
    set({
      user: null,
      isAuthenticated: false,
      isAllowed: false,
      isLoading: false,
      error: null,
    }),
}))
